import styled from 'styled-components';
import WithDirection from '@iso/lib/helpers/rtl';
import Modal from '@iso/components/Feedback/Modal';

const WeatherEmailSettingWrapper = styled(Modal)`

  .btn-success{
    width:50%;
    height:auto;
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    &:hover{
      opacity: 0.8;
    }
  }
  label.ant-checkbox-wrapper.ant-checkbox-wrapper-checked {
    align-items: center;
}
  .form-title{
    padding: 16px 24px;
    border-bottom: 1px solid #eaeef1;
    h3{
      font-size: 1rem;
    }
  }
  .form-body{
    padding: 12px 24px 12px 24px;
    .checkbox-contact{
      margin-bottom: 10px;
    }
  }
  
 .group-icon{
    display: flex;
    p{
        margin-left: 5px;
    }
 }
 .ant-checkbox{
    bottom: 4px
 }
.weather-type{
    margin-bottom: 24px;
}
.normal-label{
    margin-bottom: 8px;
}
.ant-select-multiple{
    width: 100%;
}
.weather-email-setting-btn{
    margin-top : 10px;
}
.recipients-screen {
    .recipients-list {
      max-height: 400px;
      overflow-y: auto;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
    }
    .recipient-item {
      display: flex;
      align-items: center;
      padding: 10px 12px;
      cursor: pointer;
      transition: background-color 0.2s;
      border-bottom: 1px solid #f0f0f0;
      &:last-child {
        border-bottom: none;
      }
      &:hover {
        background-color: #f5f5f5;
      }
      &.selected {
        background-color: #f0f7f2;
      }
      .ant-checkbox-wrapper {
        pointer-events: none;
      }
      .recipient-info {
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        .recipient-name {
          font-weight: 500;
          font-size: 14px;
          color: #333;
        }
        .recipient-email {
          font-size: 12px;
          color: #888;
        }
      }
    }
  }
`;

export default WithDirection(WeatherEmailSettingWrapper);